import { z } from 'zod';
export var Currency = z.object({
  code: z.string(),
  name: z.string(),
  sign: z.string()
});
export var CurrencyResponse = z.object({
  id: z.string(),
  type: z.literal('currency'),
  attributes: z.object({}).passthrough()
});